import { generateDatadogTrackingProps } from 'toolkit/environment/environment/userMonitoring.util';
import { DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ReactNode } from 'react';
import { wrapDatadogReplayTitle } from '../../../utilities/DatadogReplayText';

interface CloseableDialogTitleProps {
  title: ReactNode;
  handleClose: () => void;
}

const CloseableDialogTitle = ({
  title,
  handleClose,
}: CloseableDialogTitleProps) => {
  return (
    <DialogTitle
      sx={{
        width: '600px',
        boxSizing: 'border-box',
      }}
    >
      <Typography variant="titleLarge">
        {wrapDatadogReplayTitle(title)}
      </Typography>
      <IconButton
        {...generateDatadogTrackingProps(
          'closable-dialog-title-icon-button-close'
        )}
        aria-label="close form dialog"
        onClick={handleClose}
        sx={{
          position: 'absolute !important',
          right: '16px',
          top: '12px',
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
  );
};

export default CloseableDialogTitle;
